import { createSlice } from "@reduxjs/toolkit";

export const telephoneSlice = createSlice({
  name: "telephone",
  initialState: {
    value: "",
    countryCode: "",
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.countryCode = "";
      state.value = "";
    },
    set: (state, action) => {
      state.value = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
  },
});

export const { clear, set, setCountryCode } = telephoneSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectTelephone = (state) => state.telephone.value;
export const selectTelephoneCountryCode = (state) =>
  state.telephone.countryCode;
export default telephoneSlice.reducer;
